export default {
  GET_TASK_BUBBLES: (state) => {
    return state.bubbles;
  },
};
